/**
 * The MeetingSummaryCard draws its OWN hairline between the header and the body. The backend-authored
 * summary markdown also opens with a thematic break (`---`), which the chat markdown renderer turns into
 * a second `<hr>` — so the card showed a double border right under the subtitle (design QA "Double border
 * in morning brief"). Strip a single leading thematic break (and the blank lines around it) so only the
 * card's own divider remains. Only a LEADING rule is removed; separators later in the body are untouched.
 */

// A CommonMark thematic break: a line of 3+ of the SAME mark (`-`, `*`, or `_`), spaces allowed between.
const THEMATIC_BREAK = /^[ \t]*([-*_])(?:[ \t]*\1){2,}[ \t]*$/;

export function stripLeadingRule(content: string): string {
  const lines = content.split('\n');
  let i = 0;
  while (i < lines.length && lines[i].trim() === '') i++;
  if (i >= lines.length || !THEMATIC_BREAK.test(lines[i])) return content;
  i++;
  while (i < lines.length && lines[i].trim() === '') i++;
  return lines.slice(i).join('\n');
}
